var restOrientation = [0, 0, 0]
var calibrationRequested = false
var calibrationTimer = false
var calibrationTimerSet = false
var thresholdX = 60
var thresholdY = 50

var orientation = {
  isSupported: false,
  x: 0,
  y: 0
}

function setCalibrationRequest() {
  calibrationRequested = true
}

export function requestCalibration(delay=300) {
  // console.log('requestCalibration')
  if(!calibrationTimerSet) {
    calibrationTimer = setTimeout(setCalibrationRequest, delay)
    calibrationTimerSet = true
  }
}

function onDeviceOrientation(e) {
  // IF THIS RUNS THEN ORIENTATION IS SUPPORTED
  orientation.isSupported = true

  // CALIBRATE
  if(calibrationRequested) {
    calibrationRequested = false
    calibrationTimerSet = false
    restOrientation = [e.alpha, e.beta, e.gamma]
    // console.log(restOrientation)
  }

  // UPDATE ORIENTATION VALUES
  var orient = window.orientation || 0
  var beta = e.beta - restOrientation[1]
  var gamma = e.gamma - restOrientation[2]
  switch(orient) {  
    case -90:
      orientation.x = beta
      orientation.y = gamma
      break
    case 90:
      orientation.x = -1*beta
      orientation.y = -1*gamma
      break
    case 180:
      orientation.x = -1*gamma
      orientation.y = beta
      break
    default:
      orientation.x = -1*gamma
      orientation.y = beta
      break
  }

  if(Math.abs(orientation.x) > thresholdX || Math.abs(orientation.y) > thresholdY) {
    requestCalibration(300)
  }
}

window.addEventListener('deviceorientation', onDeviceOrientation, false)
window.addEventListener('orientationchange', requestCalibration, false)
window.addEventListener('focus', requestCalibration, false)

// Wait a bit for the initial calibration
requestCalibration(500)

export default orientation